export function googleSheetFormItemName(...names: (string | number)[]) {
  return ['googleSheet', ...names]
}
